import { TabStyles } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog, ReactConfirmationDialogBodyProps, ReactConfirmationDialogOptions } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { ResultHelper } from '../../../../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../../../../httpClient/WebHttpClient';
import { ToasterService, ToastType } from '../../../../../ts/services/ToasterService';
import { DeleteAllVersionContentOnSiteRequest } from '../../../../ServerApi/requests/DeleteAllVersionContentOnSiteRequest';

/**
 * Handles opening, error states, and cancelling.
 * Doesn't require caller to handle anything as this is a standalone button action.
 */
export function openClearSavedRevisionsDialog(): Promise<void> {
  // Custom Styling to display an uber to match the old angular implementation
  const uberBody = () =>
    <div style={{ padding: `0 ${TabStyles.Spacing.DefaultSpace}px` }}>
      <h3 style={{ fontWeight: 'normal', fontSize: TabStyles.Typography.Sizing.XLarge }}>
        {Messages.clearSavedRevisions()}
      </h3>
      <p>{Messages.clearSavedRevisionsConfirmMessage()}</p>
    </div>;

  const dialog = openReactConfirmationDialog(ClearSavedRevisionDialogOptions(uberBody));

  // Swallow the cancel rejection here
  return dialog.result.catch(() => {});
}

// Separated so can be used in a unit test, function because of Messages
export function ClearSavedRevisionDialogOptions(body: React.ComponentType<ReactConfirmationDialogBodyProps>): ReactConfirmationDialogOptions<any, void> {
  return {
    bodyComponent: body,
    actionName: Messages.clearSavedRevisionsConfirmButton(),
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width500px,
    message: null,
    paramsForAction: null,
    action: async () => {
      // Rejecting a promise would make dialog.result reject with 'cancel' which
      // should only happen when the user hits the cancel button. This is a workaround
      // to catch an error from the API call here.
      return WebHttpClient.sendRequest(new DeleteAllVersionContentOnSiteRequest())
          .then(ResultHelper.rejectResultOnError())
          .then(() => { ToasterService.instance.pop({ type: ToastType.Success, text: Messages.clearSavedRevisionsSuccess() }); })
          .catch(() => { ToasterService.instance.pop({ type: ToastType.Error, text: Messages.clearSavedRevisionsError() }); });
    }
  };
}
